import { Link } from "react-router-dom";
import "./PortableClassroom.css";

const heroImage = "/SchoolHouseFinal.png";

const itemsIncluded = [
  {
    title: "Projector Screen",
    description: "A 100-inch (16:9) cinematic screen for sizeable viewing distances, perfect for classroom settings.",
  },
  {
    title: "Portable Projector Device",
    description: "Powerful 1080p Lumens projector for both indoor and outdoor environments. Just as portable (same carry box) as 4 tablets and runs on a power bank. Compatible with screens up to 150 inches diagonal.",
  },
  {
    title: "Solar Generator and Panel",
    description: "Portable setup with 16W solar charging and 600W output charge station. Enables operation in any environment, even without a power source.",
  },
  {
    title: "Carrying Case",
    description: "Weatherproof and rugged design ensuring secure transport of all components between locations.",
  },
  {
    title: "Charging Cord",
    description: "1.5 meter fast-charging cord for efficient power delivery and extended usage periods.",
  },
  {
    title: "ChipStick",
    description: "USB stick with customizable storage options, allowing users to expand storage as needed.",
  },
  {
    title: "The ChipServer",
    description: "Our most powerful Wireless Pocket Cloud with 1TB internal storage, supporting 25+ simultaneous users with 400 Mbps upload speed and the best Tier-1 webserver-grade radios.",
  },
];

const useCases = [
  "Remote areas without stable power or internet",
  "Educational field trips or nature",
  "Temporary teaching spaces during relocation",
  "Disaster relief educational efforts",
  "Outdoor community workshops",
  "Mobile training for corporate teams",
];

export default function PortableClassroom() {
  return (
    <div className="portable-classroom">
      {/* Hero Section */}
      <header className="classroom-hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>The Portable Classroom</h1>
            <p>
              A revolutionary solution that transforms any space into a fully-equipped classroom,
              enabling education anywhere without limitations.
            </p>

            <h3>Education Without Boundaries, Bridging the Digital Divide </h3>
           
          
            <p>
              The Portable Classroom is designed to break down the barriers of traditional education
              by providing a complete, self-contained teaching environment that works anywhere—
              indoors or outdoors, with or without power infrastructure.
            </p>
            <p>
              Perfect for remote locations, field trips, emergency education scenarios, or simply
              expanding learning beyond classroom walls, our solution empowers educators to create
              immersive learning experiences anywhere.
            </p>

            <Link to="/contact">
              <button className="btn-primary">Request a Demo</button>
            </Link>
          </div>

          <div className="hero-image">
            <img src={heroImage} alt="Students using ChipServer Portable Classroom" />
          </div>
        </div>
      </header>

      {/* What's Included Section */}
      <section className="portable-included">
        <h2>What's Included</h2>
        <div className="included-grid">
          {itemsIncluded.map((item, index) => (
            <div className="included-card" key={index}>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="quote-section">
        <h2>Use Cases</h2>
        <ul className="use-cases">
          {useCases.map((useCase, index) => (
            <li key={index}>{useCase}</li>
          ))}
        </ul>

        <Link to="/contact">
          <button className="btn-primary">Get a Quote</button>
        </Link>
      </section>
    </div>
  );
}
